import { Trophy, LucideIcon } from 'lucide-react'
import { CurrencyEnum, SkillEnum, RepairEnum } from '@/types'
import { formatMultiplier, formatUnderscoreCase } from '@/utils'
import { format } from 'path'
import { useGameplayContext } from '@/contexts/gameplayContext'
interface SkillPillProps {
  skill: SkillEnum | CurrencyEnum | RepairEnum | 'All Skills'
  value: number
  Icon?: LucideIcon | string
  small?: boolean
}

export const SkillPill = ({ skill, value, Icon, small = false }: SkillPillProps) => {
  const { gameData } = useGameplayContext()
  const isPositive = value >= 1
  const IconComponent = Icon || Trophy

  return (
    <span
      className={`inline-flex items-center ${small ? 'px-1 py-0.5' : 'px-2 py-1'} rounded-full text-xs font-medium ${
        isPositive
          ? 'bg-green-100 text-green-800 border border-green-800'
          : 'bg-red-100 text-red-800 border border-red-800'
      }`}
    >
      {typeof IconComponent === 'string' ? (
        <span className={small ? 'mr-0.5' : 'mr-1'}>{IconComponent}</span>
      ) : (
        <IconComponent className={`${small ? 'w-2.5 h-2.5 mr-0.5' : 'w-3 h-3 mr-1'}`} />
      )}
      {skill === 'All Skills' ||
      gameData.currencies[skill as CurrencyEnum] ||
      gameData.skills[skill as SkillEnum]?.level >= 1
        ? formatUnderscoreCase(skill)
        : '???'}
      :
      <span
        className={`${isPositive ? 'bg-green-800 ' : 'bg-red-800'} text-white text-xs font-semibold ${
          small ? 'ml-0.5 px-1 py-0' : 'ml-1 px-1.5 py-0.5'
        } rounded-full`}
      >
        {formatMultiplier(value)}
      </span>
    </span>
  )
}
